import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Check } from "lucide-react";

export default function Services() {
  const { t } = useLanguage();
  const items = t("services.items");

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-sandSurface py-24 sm:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <div className="flex flex-col gap-10 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <p className="overline mb-4">{t("services.overline")}</p>
            <h2
              data-testid="services-title"
              className="font-display text-4xl leading-tight text-ocean sm:text-5xl lg:text-6xl"
            >
              {t("services.title")}
            </h2>
          </div>
          <p className="max-w-md text-base leading-relaxed text-mutedText">
            {t("services.subtitle")}
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-12 md:grid-cols-2 md:gap-8 lg:grid-cols-4">
          {items.map((item, idx) => (
            <article
              key={item.key}
              data-testid={`service-${item.key}`}
              className="group relative flex flex-col border-t border-warmBorder/80 pt-8 transition-all duration-300"
            >
              <span className="overline">0{idx + 1}</span>
              <h3 className="mt-6 font-display text-[1.75rem] leading-tight text-ocean sm:text-3xl">
                {item.name}
              </h3>
              <div className="mt-4 flex items-baseline gap-3">
                <span
                  data-testid={`service-price-${item.key}`}
                  className="font-display text-2xl text-terracotta"
                >
                  {item.price}
                </span>
                <span className="text-xs uppercase tracking-[0.22em] text-mutedText">
                  {item.duration}
                </span>
              </div>
              <ul className="mt-8 space-y-3 text-sm leading-relaxed text-ocean/85">
                {item.features.map((f, fi) => (
                  <li key={fi} className="flex items-start gap-3">
                    <Check
                      className="mt-[3px] h-3.5 w-3.5 flex-none text-terracotta"
                      strokeWidth={1.8}
                    />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
              <a
                href="#contact"
                data-testid={`service-cta-${item.key}`}
                className="mt-10 inline-flex items-center gap-2 self-start text-[11px] uppercase tracking-[0.26em] text-ocean underline-offset-8 hover:text-terracotta hover:underline"
              >
                {t("nav.book")}
                <span aria-hidden>→</span>
              </a>
            </article>
          ))}
        </div>

        <p className="mt-16 text-center text-xs uppercase tracking-[0.22em] text-mutedText">
          {t("services.note")}
        </p>
      </div>
    </section>
  );
}
